import i18n from '@/i18n'

const title = 'CashAvatar'

export default function getPageTitle(key) {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${title} - ${pageName}`
  }
  return `${title}`
}

